$(function() {

    const prevArrow = $(".js-prev-btn");
    const nextArrow = $(".js-next-btn");

    $('.js-inner-slider').slick({
        slidesToShow: 1,
        arrows: true,
        asNavFor: '.js-inner-thumbnail',
        vertical: false,
        autoplay: false,
        verticalSwiping: false,
        centerMode: false,
        useTransform: false,
        prevArrow: !!prevArrow.length && prevArrow,
        nextArrow: !!nextArrow.length && nextArrow,
    
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    adaptiveHeight: true
                }
            },
        ]
    });

    $('.js-inner-slider').on('init', function(event, slick) {
        console.log("initialised")
        $('.js-inner-slider').slick()
    });

    $('.js-inner-thumbnail').on('click', '[data-slide]', e=> {
        const slide = Number(e.currentTarget.dataset.slide)
        $('.js-inner-slider').slick('slickGoTo', slide)
    })

    $('.js-inner-thumbnail').slick({
        slidesToShow: 7,
        arrows: false,
        vertical: false,
        // focusOnSelect: true,
        verticalSwiping: false,
        autoplay: false,
        centerMode: false,      
        asNavFor: '.js-inner-slider',        

        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    adaptiveHeight: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                }
            },
        ]
    });
   
})
